import React from 'react'
import logo from '../assets/images/Confidences LOGO- RVB-blanc-ss fond.png'
import {Link} from 'react-router-dom'

function navBarDashboard() {
  return (
    // <div class="navbar">
    <div >
      <Link to={`/`}><img
            className="bg-logo mb-2 ng-star-inserted"
            src={logo}
            alt="logo"
            style={{borderRadius:'75px'}}
            // style={{width:'140px', height:'140px', marginLeft:'20px'}}
          />
          </Link>
          </div>
//   </div>
  )
}

export default navBarDashboard